<script setup lang="ts">
import type { PropType } from '#imports'
const props = defineProps({
  position: {
    type: Object as PropType<google.maps.LatLngLiteral>,
    required: true,
  },
  placeDetails: {
    type: Object as PropType<google.maps.places.PlaceResult>,
    required: true,
  },
});
</script>
<template>
  <div>
    <p>
      {{ props.placeDetails.formatted_address }}
    </p>
    <p>
      {{ props.placeDetails.name }}
    </p>
    <p>
      {{ props.placeDetails.website }}
    </p>
    <button id="addLocationBtn">
      Add spot
    </button>
  </div>
</template>
